import React, { useState, useEffect } from 'react';
import './App.css';
import { buildApiUrl } from './config';

function App() {
  const [showHomepage, setShowHomepage] = useState(false);

  useEffect(() => {
    const apiUrl = buildApiUrl('/homepage');
    fetch(apiUrl)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Failed to fetch homepage');
      })
      .then(data => {
        if (data.homepage_redirect) {
          window.location.href = data.homepage_redirect;
        } else {
          setShowHomepage(true);
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Homepage request failed:', error);
        setShowHomepage(true);
      });
  }, []);

  if (showHomepage) {
    return (
      <div className="App">
        <header className="App-header">
          <h1>Secure Messaging App</h1>
          <p>Our secure messaging app ensures your conversations remain private with end-to-end encryption, protecting your messages from unauthorized access. Enjoy seamless communication with a user-friendly interface, reliable performance, and robust privacy features, giving you peace of mind to connect freely and confidently.</p>
        </header>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>Loading...</h1>
      </header>
    </div>
  );
}

export default App;
